export enum RegistrationType {
  Open = 'OPEN',
  ExternalRegistration = 'EXTERNAL_REGISTRATION',
  ApprovalRequired = 'APPROVAL_REQUIRED',
} 